class EmployeeModel {
  constructor({
    id = null,
    name = null,
    email = null,
    dob = null,
    role = null,
    companyId = null,
    branchId = null,
    departmentId = null,
    jobId = null,
    phoneNumber = null,
    gender = null,
    photo = null,
    jobGroupId = null,
    directLineManager = null,
    referencedEmployeeId = null,
    customizedId = null,
    hashPass = null,
    createdAt = null,
    updatedAt = null,
    directManagerId = null,
    indirectManagerId = null,
    isAdmin = false,
    language = null,
    employmentType = "FULL_TIME",
    jobTitle = null,
    departmentName = null,
  }) {
    this.id = id;
    this.name = name;
    this.email = email;
    this.dob = dob;
    this.role = role;
    this.companyId = companyId;
    this.branchId = branchId;
    this.departmentId = departmentId;
    this.jobId = jobId;
    this.phoneNumber = phoneNumber;
    this.gender = gender;
    this.photo = photo;
    this.directLineManager = directLineManager;
    this.referencedEmployeeId = referencedEmployeeId;
    this.customizedId = customizedId;
    this.hashPass = hashPass;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.directManagerId = directManagerId;
    this.indirectManagerId = indirectManagerId;
    this.isAdmin = isAdmin;
    this.language = language;
    this.jobGroupId = jobGroupId;
    this.employmentType = employmentType;
    this.jobTitle = jobTitle;
    this.departmentName = departmentName;
  }
}

module.exports = EmployeeModel;
